import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Jaga linki

  <span style="color:#85c1dc;">**FI:**</span>
  Jaa

  <span style="color:#85c1dc;">**RU:**</span>
  Поделись
*/
/* @__NO_SIDE_EFFECTS__ */
const m353 = msg(
  mf`Jaga linki`,
  mf`Jaa`,
  mf`Поделись`,
)

export { m353 as 'w.wishlist.button.share' }